<template>
  <v-layout align-start>
    <v-flex>
    <template>
        <div>
            <v-card>
              
            <v-responsive>
                <v-card-text>
                    <v-toolbar-title>Prestacion Area</v-toolbar-title>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="4" sm="4" md="4">
                                    <v-autocomplete
                                            v-model="idCatPrestacion"
                                            :items="catBeneficio"
                                            @change="GetPrestacionArea"
                                            color="white"
                                            item-text="descripcion"
                                            item-value="idCatPrestacion"
                                            label="Descripcion"
                                        >
                                  </v-autocomplete>     
                                </v-col>
                                  <v-col cols="4" sm="4" md="4">

                                </v-col>
                                <v-col  cols="4" sm="4" md="4">
                                          <!-- ********** -->
                                            <v-dialog
                                            v-model="dialog"
                                            fullscreen
                                            hide-overlay
                                            transition="dialog-bottom-transition"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="primary" dark v-on="on" outlined
                                                >Asigna Prestaciones por Area</v-btn
                                                >
                                            </template>
                                            <v-card>
                                                <v-toolbar dark color="primary">
                                                <v-btn icon dark @click="dialog = false">
                                                    <v-icon>close</v-icon>
                                                </v-btn>
                                                <v-toolbar-title
                                                    ><span class="headline"
                                                    >Prestacion Area</span
                                                    ></v-toolbar-title
                                                >
                                                <v-spacer></v-spacer>
                                              
                                                <v-toolbar-items>
                                                    <v-btn @click="save" dark text>
                                                    Grabar
                                                    </v-btn>
                                                </v-toolbar-items>
                                                </v-toolbar>

                                                        <v-card flat>
                                                              <v-card-text>
                                                              </v-card-text>
                                                            </v-card>

                                                            <v-list three-line subheader>
                                                              <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                                              <v-container fluid>
                                                                  <v-card-text>
                                                                      <v-row>
                                                                         <v-col  cols="4" sm="4" md="4">
                                                                          <v-autocomplete
                                                                                    v-model="idCatPrestacionNew"
                                                                                    :items="catBeneficio"
                                                                                    @change="GetAsignaArea"
                                                                                    color="white"
                                                                                    item-text="descripcion"
                                                                                    item-value="idCatPrestacion"
                                                                                    label="Descripcion"
                                                                                >
                                                                          </v-autocomplete>  
                                                                        </v-col>
                                                                         <v-col  cols="8" sm="8" md="8">
                                                                          <template>
                                                                            <v-simple-table fixed-header>
                                                                              <thead>
                                                                                <tr>
                                                                                  <th class="text-left">Area</th>
                                                                                  <th class="text-left">Asignar</th>
                                                                                  <th class="text-left">Orden</th>
                                                                                </tr>
                                                                              </thead>
                                                                              <tbody>
                                                                                <tr
                                                                                  v-for="(item, index) in catPrestacionAreaAsign"
                                                                                  :key="index"
                                                                                >
                                                                                  <td>{{ item.nombreArea }}</td>
                                                                                  <td>
                                                                                    <v-container>
                                                                                      <v-checkbox
                                                                                        v-model="item.asignado"
                                                                                        :value="item.asignado"
                                                                                      >
                                                                                      </v-checkbox>
                                                                                    </v-container>
                                                                                  </td>
                                                                                  <td>
                                                                                      <v-text-field
                                                                                            type="number"
                                                                                            v-model="item.orden"
                                                                                            
                                                                                            >
                                                                                            </v-text-field>
                                                                                  </td>
                                                                                </tr>
                                                                              </tbody>
                                                                            </v-simple-table>
                                                                          </template>

                                                                        </v-col>
                                                                        </v-row>   
                                                                  </v-card-text>
                                                              </v-container>
                                                            </v-list>
                                            </v-card> 
                                            <v-divider></v-divider>
                                            </v-dialog>
                                            <!-- ********** -->
                                    </v-col>
                            </v-row>
                            
                            <v-row>
                                <!-- <v-timeline-item 
                                        :v-for="n in catPrestacionArea"
                                        :key="n"
                                        :fill-dot="false"
                                        :hide-dot="false"
                                        :icon="false ? 'mdi-star' : ''"
                                        :icon-color=" false ? 'deep-orange' : ''"
                                        :left="false"
                                        :right="false"
                                        :small="false"
                                      >
                                        <template v-slot:icon>
                                          <v-avatar v-if="false">
                                            <img src="http://i.pravatar.cc/64">
                                          </v-avatar>
                                        </template>
                                        <span slot="opposite">Tus eu perfecto</span>
                                        <v-card class="elevation-2">
                                          <v-card-title class="headline">{{n.descripcion}}</v-card-title>
                                          <v-card-text>
                                            ssas
                                          </v-card-text>
                                        </v-card>
                                      </v-timeline-item>
                                </v-timeline> -->
                               <!-- <v-timeline-item
                                  v-for="item in catPrestacionArea"
                                  :key="item.idCatArea"
                                  class="mb-4"
                                  color="pink"
                                  small
                                >
                                  <v-row justify="space-between">
                                    <v-col cols="7" v-text="item.nombreArea"></v-col>
                                   
                                  </v-row>
                               </v-timeline-item> -->
                                 <!-- <v-timeline v-for="(item, index) in catPrestacionArea" :key="index">
                                      <v-timeline-item>{{item.nombreArea}}</v-timeline-item>
                                </v-timeline> -->
                                <template>
                                   <v-col cols="4" sm="4" md="4">
                                    <v-timeline v-for="(item, index) in catPrestacionArea" :key="index">
                                          <!-- <label> {{item.index}}</label> -->
                                          <v-timeline-item>{{item.nombreArea}}</v-timeline-item>
                                          <!-- <v-timeline-item class="text-right">timeline item</v-timeline-item>
                                          <v-timeline-item>timeline item</v-timeline-item> -->
                                     </v-timeline>
                                     </v-col>
                                </template>
                            </v-row>
                    </v-container>
                  </v-card-text>
                </v-responsive>
            </v-card>
        </div>
    </template>
       
          
    </v-flex>
  </v-layout>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      catBeneficio: [],
      catPrestacionArea:[],
      catPrestacionAreaAsign:[],
      idCatPrestacion:"",
      idCatPrestacionNew:"",
      consultaDto: {
        Skip: 0,
        Take: 100,
        descending: true,
        sortBy: "",
        search: "",
        extraParam: "3",
      },
      dialog: false,
      headers: [
        { text: " ", value: " " },
        { text: "Grupo", value: "nombreGrupo" },
        { text: "Usuario", value: "nombreUsuario" },
        { text: "No Empleado", value: "noEmpleado" },
      ],
      search: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.Default();
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  methods: {
    Default() {
        debugger
      let me = this;
      me.$store.dispatch('setIsBusy', true);
      me.$axios
        .get("api/Beneficio/GetCatBeneficios")
        .then((r) => {
          if (r.data.exito) {
            me.catBeneficio = r.data.data; 
            me.$store.dispatch('setIsBusy', false);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
     GetPrestacionArea() {
        debugger
      let me = this;
      me.$store.dispatch('setIsBusy', true);
      me.$axios.get('api/PrestacionArea/Get?idCatPrestacion=' + me.idCatPrestacion)
                .then(r => {
                    if (r.data.exito) {
                        me.catPrestacionArea = r.data.data
                        me.$store.dispatch('setIsBusy', false);
                    }
                })
        .catch((e) => {
          console.log(e);
        });
    },
    GetAsignaArea() {
      debugger
      let me = this;
      me.$store.dispatch('setIsBusy', true);
      me.$axios.get('api/PrestacionArea/GetAsignaPrestacionArea?idCatPrestacion=' + me.idCatPrestacionNew)
                .then(r => {
                    if (r.data.exito) {
                        me.catPrestacionAreaAsign = r.data.datos
                        me.$store.dispatch('setIsBusy', false);
                    }
                })
        .catch((e) => {
          console.log(e);
        });
    },

      save() {
      let ctx = this;
      debugger;

      var js = {
        "catprestacioareaasign": ctx.catPrestacionAreaAsign, 
        "idcatprestacion": ctx.idCatPrestacionNew
      };

      ctx.$axios
        .post("api/PrestacionArea/Save", js)
        .then((r) => {
          if (r.data.exito) {
             ctx.$root.Mensaje(r.data.mensaje)
          }
          ctx.$store.dispatch('setIsBusy', false);
        })
        .catch((e) => {
          ctx.$store.dispatch('setIsBusy', false);
          ctx.$root.Mensaje("Ha ocurrido un imprevisto, intentelo nuevamente")
          console.log(e);
        });

     
    },
  },
};
</script>
